import { toHumanReadable } from '@core/logic';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { SelectProps } from '@mui/material/Select/Select';

export const EnumSelect = <T extends string>({
  label,
  options,
  required,
  value,
  onChange,
  multiple,
  disabled = false,
}: {
  label?: string;
  options: readonly T[];
  onChange: SelectProps<T | T[]>['onChange'];
  required?: boolean;
  value: T | T[];
  multiple?: boolean;
  disabled?: boolean;
}) => (
  <FormControl fullWidth>
    {label && <InputLabel id="enum-select-label">{label}</InputLabel>}
    <Select
      required={required}
      label={label}
      labelId="enum-select-label"
      value={value}
      onChange={onChange}
      disabled={disabled}
      multiple={multiple}
      sx={{
        maxWidth: '15rem',
      }}
    >
      {options.map((val, index) => (
        <MenuItem key={`${val}-${index}`} value={val}>
          {toHumanReadable(val)}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
